export default {
  apply_socialPitch:
    'Hjálpaðu okkur að fá smá innsýn í hver þú ert utan ferilskrár og kynningarbréfs.',
  apply_submit: 'Senda umsókn',
  apply_submitting: 'Sendi..',
  apply_cv_label: 'Ferilskrá',
  apply_coverLetter_label: 'Kynningarbréf',
  apply_email_label: 'Netfang',
  apply_name_label: 'Fullt nafn',
  apply_sex_label: 'Kyn',
  apply_ssn_label: 'Kennitala',
  apply_phone_label: 'Símanúmer',
  apply_successModal_title: 'Umsókn móttekin',
  apply_successModal_text:
    'Tölvupóstur hefur nú verið sendur á þig því til staðfestingar. Ef tölvupósturinn berst ekki innan örfárra mínútna, vinsamlegast athugið hvort að hann hafi verið flokkaður sem ruslpóstur.',
  apply_successModal_backToJobs: 'Aftur á yfirlitssíðu',
  apply_error_required: 'Þessi reitur má ekki vera tómur',
  apply_error_email: 'Innslegið netfang er ógilt',
  apply_error_ssn: 'Innslegin kennitala er ógild',
  apply_connect: 'Tengja við ',
  apply_connected: 'tengt',

  backToJobs: 'Aftur á yfirlitssíðu',
  backToDetail: 'Aftur á starfslýsingu',
  openings_singular: '{0} Starf í boði',
  openings_plural: '{0} Störf í boði',
  no_openings: 'Engin störf í boði',
  apply_button: 'Sækja um',
  deadline_display: 'Umsóknarfrestur',
  vacancies_singular: 'laust starf',
  vacancies_plural: 'laus störf',
  filter_search_placeholder: 'Leit',
  accept_terms_body_text: 'Ég hef lesið og samþykki',
  fifty_privacy_policy: ' skilmála 50skills',
  privacy_policy_and: ' og',
  company_privacy_policy: 'skilmála {0}',
  terms_agreement_required: 'Nauðsynlegt er að lesa og samþykkja skilmálana.',
  'The submitted file is empty.': 'Skráin inniheldur engin gögn',
  apply_form_has_errors: 'Villur í formi að ofan.',
  job_list_no_openings_main: 'Engar stöður lausar á þessari stundu',
  job_list_no_openings_sub: 'Kíktu aftur seinna!',
  job_list_no_language_data: 'Þetta starf hefur ekki verið þýtt á Íslensku',
  job_list_no_language_data_sub:
    'Hægt er að sjá starfið á öðrum tungumálum með því að skipta uppi hægra megin.',
  jobStatus_full_time: 'Fullt starf',
  jobStatus_part_time: 'Hlutastarf',
  jobStatus_per_diem: 'Daglaun',
  jobStatus_not_specified: 'Ótilgreint',
  en: 'English',
  is: 'Íslenska',
  pl: 'Polski',
  no: 'Norsk',
  sv: 'Svenska',
  fr: 'Français',
  languageSwitcher_title: 'Veldu tungumál',
  job_does_not_exist_header: 'Síðan sem þú ert að leita að er ekki til',
  job_does_not_exist_sub_header:
    'Þú gætir hafa stimplað inn vitlausa slóð eða starfið hefur verið fjarlægt',
  job_does_not_exist_link: 'Til baka á heimasíðuna',

  fiftyFooter_poweredBy: 'Knúið af',
  jobStatus_title: 'Ráðningarform',
  cookie_consent_main_text: 'Með því að nota síðuna samþykkirðu',
  cookie_consent_privacy_cta_text: ' notkun á kökum (e. cookies).',
  cookie_consent_privacy_button_text: 'Fela',
  department_title_unknown: 'Ótilgreint {0}',
  helpers_add: 'Bæta við skrá',
};
